export const requestConfig = {
  url: '/api/v1',
  // url: '/proxy',
  timeout: 30000
}



// WEBPACK FOOTER //
// ./src/api/index.js